import { css } from '@mui/material/styles';
export const inputLabelComponentOverrides = {
    MuiInputLabel: {
        defaultProps: {
            shrink: true
        },
        styleOverrides: {
            root: ({ theme }) => css `
                color: ${theme.tokens.FuelColorGray900};
                font-size: ${theme.typography.button.fontSize};
                font-weight: ${theme.typography.button.fontWeight};
                margin-bottom: ${theme.spacing(1)};
                display: block;

                &.Mui-focused {
                    color: ${theme.tokens.FuelColorTextPrimary};
                }

                &.MuiInputLabel-shrink {
                    transform: none;
                    position: relative;
                    height: auto;
                    overflow: hidden;
                    line-height: ${theme.spacing(5)};
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                &[data-fuel-hidden-label=true] {
                    display: none;
                }

                &.Mui-disabled {
                    color: ${theme.tokens.FuelColorTextTertiary};
                    opacity: 0.4;
                }
            `
        }
    }
};
